export const DEFAULT_CRM_TABS = {
  "Community + Chat": true,
  "Onboarding + Referral": true,
  "Social + Content": true,
  Gamification: true,
  Rewards: true,
  Marketplace: true,
  Bespoke: true,
  Programme: true,
  Integration: true,
  "Support Chat": true,
};

export const CRM_TABS = Object.keys(DEFAULT_CRM_TABS);



// WEBPACK FOOTER //
// ./src/screens/BespokeCRMTabs/constants.js